var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"help-screen-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"overlay\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"content-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<span id=\"close\" onclick=\"this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, jade_debug[0].filename ));
buf.push("x");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<h3>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 6, jade_debug[0].filename ));
buf.push("Keyboard shortcuts table");
jade_debug.shift();
jade_debug.shift();
buf.push("</h3>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<table>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<thead>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 12, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 12, jade_debug[0].filename ));
buf.push("OS X");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, jade_debug[0].filename ));
buf.push("Windows");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 16, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 16, jade_debug[0].filename ));
buf.push("Function");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.shift();
buf.push("</thead>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 17, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tbody>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 18, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"3\" class=\"section\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, jade_debug[0].filename ));
buf.push("Video controls");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 20, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 21, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"2\" class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 22, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key space\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 23, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, jade_debug[0].filename ));
buf.push("Play/Pause");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 25, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 26, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"2\" class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 27, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key arrow-up\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 28, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 29, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 29, jade_debug[0].filename ));
buf.push("Volume up");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 30, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 31, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"2\" class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 32, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key arrow-down\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 33, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 34, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 34, jade_debug[0].filename ));
buf.push("Volume down");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 35, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 36, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"2\" class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 37, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key arrow-left\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 38, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 39, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 39, jade_debug[0].filename ));
buf.push("Jump back 1 frames");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 40, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 41, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"2\" class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 42, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key arrow-right\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 43, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 44, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 44, jade_debug[0].filename ));
buf.push("Jump forward 1 frames");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 45, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 46, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td colspan=\"3\" class=\"section\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 46, jade_debug[0].filename ));
buf.push("Subtitle controls");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 47, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 48, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 49, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 50, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key a\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 51, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 52, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 53, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key a\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 54, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 55, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 55, jade_debug[0].filename ));
buf.push("Add subtitle");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 56, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 57, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 58, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 59, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key b\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 60, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 61, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 62, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key b\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 63, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 64, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 64, jade_debug[0].filename ));
buf.push("Toggle subtitle black background(only for display)");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 65, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 66, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 67, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 68, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 69, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 70, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 71, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 72, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 73, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 73, jade_debug[0].filename ));
buf.push("Search for subtitle");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 74, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 75, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 76, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 77, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key j\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 78, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 79, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 80, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key j\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 81, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 82, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 82, jade_debug[0].filename ));
buf.push("Jump to popup");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 83, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 84, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 85, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 86, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key i\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 87, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 88, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 89, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key i\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 90, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 91, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 91, jade_debug[0].filename ));
buf.push("Toggle italic");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 92, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 93, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 94, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 95, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key m\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 96, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 97, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 98, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key m\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 99, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 100, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 100, jade_debug[0].filename ));
buf.push("Merge subtitles");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 101, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 102, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 103, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 104, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key s\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 105, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 106, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 107, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key s\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 108, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 109, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 109, jade_debug[0].filename ));
buf.push("Split subtitles");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 110, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 111, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 112, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 113, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 114, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 115, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 116, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 117, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 118, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 118, jade_debug[0].filename ));
buf.push("Undo changes");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 119, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 120, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 121, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 122, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key y\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 123, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 124, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 125, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key y\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 126, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 127, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 127, jade_debug[0].filename ));
buf.push("Redo changes");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 128, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 129, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 130, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 131, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key backspace\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 132, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 133, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 134, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key backspace\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 135, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 136, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 136, jade_debug[0].filename ));
buf.push("Delete subtitles");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 137, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 138, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 139, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key cmd\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 140, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key u\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 141, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"shortcut\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 142, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key ctrl\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 143, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<div class=\"key u\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 144, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<td class=\"description\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 145, "C:\\Dev\\repos\\player\\app\\templates\\help-screen.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 145, jade_debug[0].filename ));
buf.push("Toggle sync");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tbody>");
jade_debug.shift();
jade_debug.shift();
buf.push("</table>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".help-screen-wrapper\r\n\t.overlay\r\n\t.content-wrapper\r\n\r\n\t\tspan#close(onclick='this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;') x\r\n\t\th3 Keyboard shortcuts table\r\n\r\n\t\ttable\r\n\t\t\tthead\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd\r\n\t\t\t\t\t\tp OS X\r\n\t\t\t\t\ttd\r\n\t\t\t\t\t\tp Windows\r\n\t\t\t\t\ttd\r\n\t\t\t\t\t\tp Function\r\n\t\t\ttbody\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.section(colspan=3) Video controls\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd(colspan=2).shortcut\r\n\t\t\t\t\t\t.key.space\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Play/Pause\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd(colspan=2).shortcut\r\n\t\t\t\t\t\t.key.arrow-up\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Volume up\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd(colspan=2).shortcut\r\n\t\t\t\t\t\t.key.arrow-down\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Volume down\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd(colspan=2).shortcut\r\n\t\t\t\t\t\t.key.arrow-left\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Jump back 1 frames\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd(colspan=2).shortcut\r\n\t\t\t\t\t\t.key.arrow-right\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Jump forward 1 frames\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.section(colspan=3) Subtitle controls\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.a\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.a\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Add subtitle\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.b\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.b\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Toggle subtitle black background(only for display)\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.f\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.f\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Search for subtitle\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.j\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.j\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Jump to popup\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.i\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.i\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Toggle italic\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.m\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.m\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Merge subtitles\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.s\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.s\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Split subtitles\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.z\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.z\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Undo changes\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.y\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.y\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Redo changes\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.backspace\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.backspace\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Delete subtitles\r\n\t\t\t\ttr\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.cmd\r\n\t\t\t\t\t\t.key.u\r\n\t\t\t\t\ttd.shortcut\r\n\t\t\t\t\t\t.key.ctrl\r\n\t\t\t\t\t\t.key.u\r\n\t\t\t\t\ttd.description\r\n\t\t\t\t\t\tp Toggle sync");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/help-screen.jade
// module id = 415
// module chunks = 0